import React from 'react';
import { Plane, Clock, IndianRupee } from 'lucide-react';
import { airportForCity } from '@/data/essentials_b';

export default function AirportCard({ cityName, countryCode }) {
  const d = airportForCity(cityName, countryCode);
  if (!d) return null; // silently hide if no curated data
  return (
    <div className="puvio-card p-5" data-testid="airport-card">
      <div className="flex items-start justify-between">
        <div>
          <p className="font-bold text-[11px] uppercase tracking-[0.22em] text-[var(--puvio-mint-deep)]">Airport to city</p>
          <p className="text-xs text-[var(--puvio-text-2)] mt-0.5 font-medium" data-testid="airport-name">{d.name}</p>
        </div>
        <div className="w-12 h-12 rounded-2xl flex items-center justify-center" style={{ background: '#E0E8FF' }}>
          <Plane className="w-6 h-6 text-[#0F1A13]" />
        </div>
      </div>
      <ul className="mt-4 flex flex-col gap-2">
        {d.options.map((o, i) => (
          <li key={i} className="flex items-start gap-3 px-3 py-2.5 rounded-2xl bg-[var(--puvio-bg-soft)] border border-[var(--puvio-border)]" data-testid={`airport-option-${i}`}>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-extrabold text-[#0F1A13]">{o.mode}</p>
              <p className="text-[11px] text-[var(--puvio-text-2)] flex flex-wrap items-center gap-x-3 gap-y-0.5 mt-0.5 font-medium">
                <span className="inline-flex items-center gap-1"><Clock className="w-3 h-3" />{o.time}</span>
                <span className="inline-flex items-center gap-1"><IndianRupee className="w-3 h-3" />{o.cost}</span>
              </p>
              {o.note && <p className="text-[11px] text-[var(--puvio-text-3)] mt-0.5">{o.note}</p>}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
